export default {
	properties: [
		{
			text: 'Nombre',
			key: 'name',
			type: 'text',
			value: '',
			is_title: true,
		},
	],
	singular_model_name_spanish: 'Condicion',
	plural_model_name_spanish: 'Condiciones',
	create_model_name_spanish: 'Nueva',
	text_delete: 'la',
}